import axios from 'axios'
const url = "https://www.lefisc.com.br/api/reclef"

export default{  
    visualizar(caminhoConsulta){
        return axios
        .get(`${caminhoConsulta}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    remover(id){       
        return axios
        .delete(`${url}/consultas?hash=${id}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    getConsulta(id){
        return axios
        .get(`${url}/consultas?hash=${id}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    enviarNotas(id,json){
        return axios
        .post(`${url}/upload?hash=${id}`,json)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
}